<template>
	<div id="chat" :class="view" class="custom-chat">
		<div class="head">
			<div class="manager" v-if="!orderId">
				<div class="info">
					<strong class="name">{{ collocutor.name }}</strong>
					<span v-if="collocutor.role === 'client'" class="role">{{getUserRole(collocutor.role) }}</span>
					<span v-else class="role">{{ $t('chatWithYourManager(p1)') }} <b>{{ $t('chatWithYourManager(p2)') }}</b></span>
				</div>
			</div>
			<div class="info" v-else>
				<span>{{ $t('chatByOrder') }} <strong class="name">№ {{ orderId }}</strong></span>
			</div>
			<div class="buttons">
				<vs-button class="fullSize" @click="view = view === 'full' ? 'mini' : 'full'">
					<svg width="22" height="20" x="0" y="0" class="stencil--easier-to-select" style="opacity: 1;">
						<defs></defs>
						<rect x="0" y="0" width="22" height="20" fill="transparent"
							  class="stencil__selection-helper"></rect>
						<path
							d="M19.555555555555557 0C19.555555555555557 0 2.4444444444444446 0 2.4444444444444446 0 1.094415055969172 0 0 1.119288125423017 0 2.5 0 2.5 0 17.5 0 17.5 0 18.88071187457698 1.094415055969172 20 2.4444444444444446 20 2.4444444444444446 20 19.555555555555557 20 19.555555555555557 20 20.900000000000002 20 22 18.875 22 17.5 22 17.5 22 2.5 22 2.5 22 1.119288125423017 20.905584944030828 0 19.555555555555557 0 19.555555555555557 0 19.555555555555557 0 19.555555555555557 0M19.555555555555557 17.5C19.555555555555557 17.5 2.4444444444444446 17.5 2.4444444444444446 17.5 2.4444444444444446 17.5 2.4444444444444446 5 2.4444444444444446 5 2.4444444444444446 5 19.555555555555557 5 19.555555555555557 5 19.555555555555557 5 19.555555555555557 17.5 19.555555555555557 17.5 19.555555555555557 17.5 19.555555555555557 17.5 19.555555555555557 17.5"
							stroke-width="0" stroke="none" stroke-dasharray="none" fill="rgb(98, 98, 98)"
							fill-rule="evenOdd"></path>
					</svg>
				</vs-button>
				<vs-button class="turn" @click="$store.dispatch('hideChat')">
					<svg width="20" height="20" x="0" y="0" class="stencil--easier-to-select" style="opacity: 1;">
						<defs></defs>
						<rect x="0" y="0" width="20" height="20" fill="transparent"
							  class="stencil__selection-helper"></rect>
						<path
							d="M20 2.014285714285715C20 2.014285714285715 17.985714285714288 0 17.985714285714288 0 17.985714285714288 0 10 7.985714285714285 10 7.985714285714285 10 7.985714285714285 2.014285714285715 0 2.014285714285715 0 2.014285714285715 0 0 2.014285714285715 0 2.014285714285715 0 2.014285714285715 7.985714285714285 10 7.985714285714285 10 7.985714285714285 10 0 17.985714285714288 0 17.985714285714288 0 17.985714285714288 2.014285714285715 20 2.014285714285715 20 2.014285714285715 20 10 12.014285714285716 10 12.014285714285716 10 12.014285714285716 17.985714285714288 20 17.985714285714288 20 17.985714285714288 20 20 17.985714285714288 20 17.985714285714288 20 17.985714285714288 12.014285714285716 10 12.014285714285716 10 12.014285714285716 10 20 2.014285714285715 20 2.014285714285715"
							stroke-width="0" stroke="none" stroke-dasharray="none" fill="rgb(98, 98, 98)"
							fill-rule="evenOdd"></path>
					</svg>
				</vs-button>
			</div>
		</div>

		<div class="body custom-chat-body">
			<div class="search">
				<vx-input-group>
					<div class="vs-component vs-con-input-label vs-input vs-input-primary">
						<div class="vs-con-input">
						</div>
						<vs-input class="inputx" placeholder="" v-model="searchInput"/>
					</div>
					<template slot="append">
						<div class="append-text btn-addon">
							<vs-button
								color="primary"
								placeholder=""
								type="filled"
								@click="search = searchInput"
							>{{ $t('search') }}</vs-button>
						</div>
					</template>
				</vx-input-group>
			</div>
			<VuePerfectScrollbar
				ref="verticalNavMenuPs"
				:key="$vs.rtl"
				:settings="settings"
				@ps-scroll-y="psSectionScroll"
				@scroll="psSectionScroll"
				class="scroll-area-v-nav-menu"
			>
<!--				<transition name="fade">-->
					<div>
						<div class="day" v-for="day in filteredList">
							<!-- <span class="date">{{ day.created | moment('YYYY-MM-DD') }}</span> -->
<!--							<transition-group name="flip-list">-->
								<template v-for="(message, index) in day.messages">
									<div
										style="padding-bottom: 5px !important;"
										v-if="message.type === 'system'"
										class="break-words hyphens-auto p-4"
									>
										<div class="frsSystemMessageTop">
											<div class="float-left">
												<strong>{{ $t('titleSystemMessage') }}</strong>
											</div>
											<div class="float-right">
												<strong>{{ message.created | moment('DD.MM.YYYY HH:mm:ss') }}</strong>
											</div>
										</div>
										<div class="frsSystemMessageBody">
											<MessageBody :text="message.message" />
										</div>
									</div>
									<div
										v-if="message.type === 'system'"
									>
										<div 
											class="fsrTrekingTimeSystem"
											v-if="message.user.role !== 'client'"
											style="text-align: center;"
										>
											<span
												:class="{ timeGreen : message.counterViews>0, timeRed : message.counterViews<1}"
											>
												{{ $t('chatTrekingOpensTimes') }}: <strong>{{message.counterViews}}</strong>
											</span>
											<span 
												v-if="message.user.role !== 'client' 
														&& message.counterViews>0 
														&& message.dateLastView != '0000-00-00 00:00:00'"
											>
												| {{ $t('chatTrekingLastOpened') }} ({{ message.dateLastView | moment('DD.MM.YYYY HH:mm:ss') }})
											</span>
										</div>
										<hr class="w-full mb-3">
									</div>
									<div class="message"
										 :key="message.id"
										 v-else-if="message.type !== 'system'"
										 :class="{isManager: !message.is_my_message}"
									>
										<div class="top">
											<div class="author">
												<div class="avatar">
													<img
														v-if="message.user.photo"
														:src="filePath(message.user.photo)"
														alt=""
													>
													<feather-icon icon="UserIcon" class="client-avatar" />
												</div>
												<div class="name">
													<strong>{{ message.user.username }}</strong>
													<div class="role">
														{{ message.user.role !== 'client' ? getUserRole(message.user.role) : " " }}
														<div 
															v-if="message.asAuthor" 
															class="fsrAsAuthorTitle"
														>
															{{ $t('sendFromAuthor') }}
														</div>
													</div>
												</div>
											</div>

											<div>
												<div class="time">
													{{ message.created | moment('DD.MM.YYYY HH:mm:ss A') }}
												</div>
												<div 
													class="time"
													v-if="message.user.role !== 'client'"
													:class="{ timeGreen : message.counterViews>0, timeRed : message.counterViews<1}"
												>
													{{ $t('chatTrekingOpensTimes') }}: <strong>{{message.counterViews}}</strong>
												</div>
												<div 
													class="time"
													v-if="message.user.role !== 'client' 
															&& message.counterViews>0 
															&& message.dateLastView != '0000-00-00 00:00:00'"
												>
													{{ $t('chatTrekingLastOpened') }} ({{ message.dateLastView | moment('DD.MM.YYYY HH:mm:ss') }})
												</div>
											</div>

										</div>
										<p class="main">
											<MessageBody :text="message.message" />
										</p>
									</div>
<!--									<div class="info" v-else :key="message.id">-->
<!--										<span v-html="message.message"></span>-->
<!--									</div>-->
								</template>
<!--							</transition-group>-->
						</div>
					</div>
<!--				</transition>-->
				<div id="end-of-messages"></div>
			</VuePerfectScrollbar>
		</div>

		<vue-editor v-model="msg" />

		<div class="send">
			<vx-input-group>
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<div class="vs-con-input">
					</div>
				</div>
				<template slot="append">
					<div class="append-text btn-addon">
						<vs-checkbox
							v-model="asAuthor"
							class="text-black mr-5"
						>	
							{{ $t('sendFromAuthor') }}
						</vs-checkbox>

						<vs-button color="primary" @click="addMessage" type="filled">{{ $t('send') }}</vs-button>
					</div>
					&nbsp;
					<div
						v-if="$store.state.auth.role === 'manager' && isChatUnread"
						class="append-text btn-addon">
						<vs-button color="success" @click="addMarkAsRead">{{ $t('txtBtnChatMarkAsRead') }}</vs-button>
					</div>
				</template>
			</vx-input-group>
			<label class="file-input">
				<div class="file-input__container">
					<feather-icon class="file-input__img" icon="PaperclipIcon" />
				</div>
				<input ref="fileInput" type="file" class="hidden" @input="uploadFile">
			</label>
			<vs-dropdown
				v-if="$store.state.auth.role === 'manager'"
				vs-custom-content
				vs-trigger-click
				vs-collapse
				:fixed="true"
				class="circle cursor-pointer"
				icon="MoreHorizontalIcon"
			>
				<vs-button
					@click="addMessage"
					color="primary"
					type="filled"
					class="flex justify-center items-center"
				>
					<feather-icon icon="MoreHorizontalIcon" class="flex items-center"/>
				</vs-button>

				<vs-dropdown-menu
					v-if="quickMessages.length > 0"
					:fixed="true"
					class="chat-template-messages"
				>
					<VuePerfectScrollbar class="chat-template-messages__container">
						<vs-dropdown-item v-for="item in quickMessages" @click="msg = item.message">
							{{ item.name }}
						</vs-dropdown-item>
					</VuePerfectScrollbar>
				</vs-dropdown-menu>
			</vs-dropdown>
		</div>
	</div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import MessageBody from './MessageBody';
import FeatherIcon from "@/components/FeatherIcon";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import { VueEditor } from "vue2-editor";

let updatingInterval = null;

export default {
	name: "Chat",
	mixins: [databaseManager, notifier],
	components: {
		FeatherIcon,
		MessageBody,
		VuePerfectScrollbar,
		VueEditor,
	},
	data() {
		return {
			asAuthor: false,
		};
	},
	watch: {
		searchInput(newValue) {
			if(newValue === "") {
				this.search = "";
			}
		},
		'$store.state.chat.is_chat_unread'(value, oldValue) {
			this.isChatUnread = value;
 		},
	},
	computed: {
		orderId() {
			const payload = this.$store.state.chat.payload;
			if(!payload || !payload.id) return null;
			return 	payload.id;
		},
		collocutor() {
			return this.$store.state.chat.collocutor;
		},
		filteredList() {
			if (!this.search) {
				const scrollToBottom = this.checkIfAtTheBottom();
				this.scrollToBottom(scrollToBottom);
				return this.messages;
			}

			const result = Object.values(this.messages).map(post => {
				let messages = post.messages.filter(message => {
					if (message.message.toLowerCase().includes(this.search.toLowerCase())) {
						return message
					}
				})
				if (messages.length > 0) {
					return {
						created: post.created,
						messages
					}
				} else return null
			}).filter(e => e !== null);

			if(result.length !== 0) {
				this.scrollToBottom(false);
			}

			return result;
		}
	},
	methods: {
		getUserRole(role) {
			if(role === "manager") {
				return this.$t('manager');
			} else if(role === "author") {
				return this.$t('copywriter');
			} else if(role === "admin") {
				return this.$t('admin');
			} else if(role === "partner") {
				return this.$t('partner');
			} else if(role === "client") {
				return this.$t('client');
			}

			return "";
		},
		scrollToBottom(isImportant = true) {
			this.$nextTick(() => {
				if(isImportant !== true) return;

				const endOfMessages = document.getElementById("end-of-messages");

				let count = 0;
				for(let day of Object.values(this.filteredList)) {
					count += day.messages.length;
				}

				if(endOfMessages !== null) {
					endOfMessages.scrollIntoView(false);
				} else {
					this.$refs.verticalNavMenuPs.$el.scrollTop = 1000000;
				}
			});
		},
		checkIfAtTheBottom() {
			if(this.$refs.verticalNavMenuPs === undefined) return true;

			const scrollbar = this.$refs.verticalNavMenuPs.$el;
			return scrollbar.scrollHeight - scrollbar.scrollTop === scrollbar.clientHeight;
		},
		psSectionScroll() {
			const scroll_el = this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs
			this.showShadowBottom = scroll_el.scrollTop > 0
		},
		revers(array){
			return array.reverse();
		},
		async updateMessage(clearInput = true, scrollToBottom = false) {
			let data = this.$store.state.chat.messages;

			if(data.length > 0){
				let messages = {};
				data.forEach( curr=> {
					let date = curr.created.split(' ')[0];
					if(messages[date])
						messages[date].messages.push(curr);
					else {
						messages[date] = {};
						messages[date].messages = [];
						messages[date].created = curr.created;
						messages[date].messages.push(curr)
					}
				})

				Object
					.values(messages)
					.forEach(e=>e.messages.reverse());

				this.messages = Object
					.keys(messages)
					.sort()
					.reduce((r, k) => (r[k] = messages[k], r), {})
			}

			if(clearInput) {
				this.msg = '';
			}
			this.scrollToBottom(scrollToBottom);
		},
		filePath(file) {
			if (!file) {
				return;
			}

			const fileName = file.toLowerCase();
			return fileName;
		},
		async uploadMessage(message, encode = true) {
			try {
				const msg = encode ? encodeURI(message) : message;
				const asAuthor = this.asAuthor;
				await this.$store.dispatch('sendMessage', { msg, asAuthor });

				const atBottom = this.checkIfAtTheBottom();
				await this.updateMessage(true, atBottom);
				setTimeout(() => this.loadMessages(), 100);

			} catch (error) {
				console.error(error)
			}
		},
		addMessage() {
			this.uploadMessage(this.msg)
			this.msg = '';
		},
		async addMarkAsRead() {
            try {
				const idChat = this.$store.state.chat.idChat;
				const rezMark = await this.dbChatClientMarkAsRead(idChat);
				if(rezMark) {
					this.isChatUnread = false;
					this.notifySuccess(`${this.$t('notifySuccessChatMarkAsRead')}`);
				}
            } catch(e) {
                this.notifyError(e.message);
            }
		},
		async uploadFile() {
			try {
				const [file] = this.$refs.fileInput.files;
				const idChat = this.$store.state.chat.idChat;
				const [uploadedFile] = await this.dbUploadMany([file], idChat);
				const messageText = `<a>${uploadedFile.fullUrl}</a>`;

				await this.uploadMessage(messageText, false);
			} catch (e) {

			}
		},
		async loadMessages(scrollToBottom = false) {
			if(updatingInterval !== null) clearInterval(updatingInterval);

			let res = await this.$store.dispatch('getMessages');
			const isScroll = scrollToBottom || this.checkIfAtTheBottom();

			if(res === undefined) return;

			await this.updateMessage(false, isScroll);

			updatingInterval = setInterval(() => this.loadMessages(), 30000);
		}
	},

	async mounted() {
		this.quickMessages = (await this.$http.get('/chat/get-chat-response-templates/'+this.orderId)).data.data;
		this.isChatUnread = this.$store.state.chat.is_chat_unread;

		this.loadMessages(true);
	},

	data() {
		return {
			view: 'mini', // mini, full
			search: '',
			searchInput: '',
			msg: '',
			isChatUnread: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 1,
				swipeEasing: true
			},
			// updatingInterval: null,
			messages: [],
			quickMessages: []
		}
	}
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/vuexy/functions";
@import "../../assets/scss/vuexy/variables";

.fsrAsAuthorTitle {
	font-size: smaller;
	font-style: italic;
	font-weight: bold;
}

.flip-list-move {
	transition: transform 1s;
}

.flip-list-enter, .flip-list-leave-to {
	opacity: 0;
}

.fade-enter-active, .fade-leave-active {
	transition: opacity 1s;
}

.fade-enter, .fade-leave-to {
	opacity: 0;
}

// .con-vs-dropdown--menu {
// 	z-index: 999991;
// }

// #chat .tox {
// 	z-index: 999992 !important;
// }
// #chat .tox-tiered-menu{
// 	z-index: 999983 !important;
// }
// #chat .tox-menu {
// 	z-index: 999994 !important;
// }
.tox-menu {
	z-index: 999995 !important;
}

#chat {
	width: 700px;
	border-radius: 8px;
	border: 2px solid #e4e4e4;
	background-color: #fff;
	overflow: hidden;
	position: fixed;
	bottom: 0;
	left: calc(100% - 730px);
	z-index: 999990;
	//transition: 0.5s;
	//transform: translate(0);

	.ps-container {
		padding: 0 16px;
	}

	.ps-container {
		height: 300px;
	}

	&.full {
		left: 0;
		width: 100vw;
		height: 100vh;
		border-radius: 0;

		.ps-container {
			height: 47vh;
		}

		.send {
			position: fixed;
			width: 100%;
			bottom: 0;
			left: 0;
			z-index: 999;
			background-color: #fff;
		}
	}

	.head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 16px;
		border-bottom: 2px solid #e4e4e4;


		.manager {
			display: flex;
			align-items: center;

			.photo {
				display: flex;
				align-items: center;
				margin-right: 10px;
			}

			.info {
				display: flex;
				flex-direction: column;
				font-size: rem(16px);

				.name {
					font-size: rem(16px);
					display: flex;
					flex-direction: column;
					justify-content: center;
					line-height: 1;
				}
			}
		}

		.buttons {
			.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
				padding: 8px;
				background-color: transparent !important;

				&--background {
					display: none !important;
				}
			}

			svg path {
				transition: .25s;
			}

			.vs-button:hover {
				background-color: transparent !important;
				box-shadow: none;

				svg path {
					fill: $primary;
				}
			}

			.vs-button.isActive {
				background-color: transparent !important;
			}
		}
	}

	.body {
		background-color: #e8eaf6;
		padding-bottom: 20px;

		.search {
			padding: 20px 16px;
			padding-bottom: 0;
		}

		.date {
			width: 100%;
			display: inline-block;
			text-align: center;
			padding-bottom: 20px;
			padding-top: 10px;
		}

		.message {
			background-color: #fff;
			border-radius: 8px;
			padding: 9px;
			width: 89%;
			margin-bottom: 20px;
			margin-left: auto;
			box-shadow: 0px 2px 5px 0px #0000001f;

			&:last-child {
				margin-bottom: 0;
			}

			&.isManager {
				margin-left: 0;
			}

			.main {
				padding-top: 7px;
				word-break: break-word;
				hyphens: auto;
			}

			.author {
				display: flex;
				align-items: center;
				padding-bottom: 5px;

				.avatar {
					margin-right: 10px;
					width: 40px;
					height: 40px;
					overflow: hidden;
					border-radius: 100%;

					img {
						max-width: 100%;
						height: 100%;
						width: 100%;
					}
				}

				.client-avatar {
					display: flex;
					justify-content: center;
					align-items: center;
					border-radius: 100%;
					width: 100%;
					height: 100%;
					//background-color: #eaeaea;
					background-color: #42A5F5;
					color: white;

					svg {
						width: 75%;
						height: 75%;
					}
				}

				.name {
					font-size: rem(16px);
					display: flex;
					flex-direction: column;
					justify-content: center;
					line-height: 1;
				}
			}

			.top {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				border-bottom: 2px solid #d6d6d6;
			}

			.time {
				font-weight: 500;
				font-size: rem(12px);
				text-align: right;
			}

		}

		.info {
			text-align: center;
			padding-bottom: 20px;

			&:last-child {
				padding-bottom: 0;
			}
		}
	}

	.send {
		padding: 10px 16px;
		display: flex;

		.vx-input-group {
			width: 100%;
		}

		.file-input {
			border-radius: 100%;
			margin-left: 10px;
			flex: 37px 0 0;
			width: 37px;
			height: 37px;
			overflow: inherit;
			padding: 0;
			background-color: $primary;
			cursor: pointer;

			&__container {
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 100%;
				padding: 0;
				width: 100%;
				height: 100%;
			}

			&__img {
				width: 22px;
				height: 22px;
				color: white;
			}
		}

		.circle button {
			overflow: hidden;
			width: 37px;
			height: 37px;
			flex-shrink: 0;
			text-align: center;
			padding: 0;
			border-radius: 100%;
			margin-left: 10px;
		}
	}
}

.custom-chat {
	&-body {
		.day {
			padding-bottom : 5px;
		}
	}

	.scroll-area-v-nav-menu {
		margin-top: 10px;
		padding: 0 16px 20px 16px;
		height: 300px;
	}
}

.chat-template-messages {
	z-index: 999991 !important;
	width: 300px !important;

	&__container {
		max-height: 200px;
		overflow-y: auto;
	}
}

.fsrTextAreaChat {
	width: 100%;
}
.fsrDivTextAreaChat {
	padding: 10px 16px 0px;
	margin-bottom: 0px;
	display: flex;
}
.fsrTrekingTimeSystem {
	font-weight: 500;
	font-size: rem(12px);
	margin: auto;
	clear: both;
	display: block !important;
	width: 100%;
	padding-bottom: 10px !important;
}

.frsSystemMessageTop {
	margin: auto;
	width: 100%;
	display: block !important;
	padding-bottom: 10px;
	font-weight: 500;
	font-size: rem(12px);
}
.frsSystemMessageBody {
	margin-top: 20px;
	clear: both;
}

.timeRed {
	color: red;
}
.timeGreen {
	color: green;
}

</style>
